module.exports = __webpack_public_path__ + "static/media/salesforce.8b010ecc.png";